import moment from 'moment';

// Продукт
class Product {
  constructor(id, name, productId, quantity, checked, calculateBonuses) {
    this.#id = id;
    this.#name = name;
    this.#quantity = quantity;
    this.#productId = productId;
    this.checked = checked;
    this.#calculateBonuses = calculateBonuses;
    // Для того, чтобы у Vue работала реактивность
    new Proxy(this, {
      get(target, p) {
        target[p];
      },
      set(target, p, value) {
        target[p] = value;
        if (p === 'checked' || p === 'quantity') {
          target.#calculateBonuses();
        }
        return true;
      },
    });
  }

  // Идентификатор
  #id;

  // Наименование
  #name;

  // Количество
  #quantity;

  // Идентификатор позиции
  #productId;

  // Диалог для мобилки
  mobileDialog = false;

  // Выбран ли продукт?
  checked;

  // eslint-disable-next-line camelcase
  number_photos = [];

  // eslint-disable-next-line camelcase
  model_photos = [];

  get name() {
    return this.#name;
  }

  set name(name) {
    this.#name = name;
  }

  get quantity() {
    return this.#quantity;
  }

  set quantity(value) {
    this.#quantity = value;
    this.#calculateBonuses();
  }

  get id() {
    return this.#id;
  }

  set id(value) {
    this.#id = value;
  }

  // Рассчитать бонусы
  #calculateBonuses;
}

/** Табличка для отображения продуктов */
export default {
  props: ['products', 'positions', 'actionId', 'ticket'],
  data() {
    return {
      displayProducts: [],
      // Список идентификаторов выбранных в таблице элементов
      selectedItemsInTable: [],
      // Всего начислено бонусов
      totalBonuses: 0,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    selectedItemsInTable(newArray, oldArray) {
      if (newArray.length !== oldArray.length) {
        this.calculateBonuses();
      }
    },
  },
  methods: {
    openItemDialog(item) {
      if (item.checked) {
        item.mobileDialog = true;
      }
    },
    onProductCheck(item) {
      if (item.checked) {
        this.selectedItemsInTable.push(item.id);
      } else {
        item.quantity = 0;
        this.selectedItemsInTable = this.selectedItemsInTable.filter(
          id => id !== item.id,
        );
      }
    },
    calculateBonuses() {
      if (this.selectedItemsInTable.length === 0) {
        this.totalBonuses = 0;
        return;
      }
      const positions = this.getPositions();
      if (!positions.length) {
        return;
      }
      const form = {
        action_id: this.actionId,
        positions,
      };
      form.profile_id = this.user.profile_id;
      form.date_setup_local = moment().format('DD.MM.YYYY');
      this.$store.getters.axl
        .post('sales/api/bonus/calculate', form)
        .then((response) => {
          this.totalBonuses = response.data.bonuses.total;
        });
    },
    /**
     * Обработка нажатия на кнопку в поле ввода количества, запрещаем вводить символ минуса "-"
     * @param event
     */
    onQuantityKeydown(event) {
      if (event.key === '-') {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    getPositions() {
      return this.selectedItemsInTable
        .filter((el) => {
          const product = this.displayProducts.find(pr => pr.id === el);
          const quantityAsNumber = Number(product.quantity);
          if (Number.isNaN(quantityAsNumber)) {
            return false;
          }
          return quantityAsNumber > 0;
        })
        .map((el) => {
          const productItem = this.displayProducts.find(pr => pr.id === el);
          let id;
          if (this.ticket) {
            const position = this.ticket.positions.find(pos => productItem.id === pos.product_id);
            id = position?.id;
          }
          return {
            id,
            quantity: Number(productItem.quantity),
            product_id: productItem.id,
            number_photos: productItem.number_photos,
            model_photos: productItem.model_photos,
          };
        });
    },
  },
  mounted() {
    // Бэкенд отдаёт products: null, если у акции выключен show_products_in_table
    const actionProducts = JSON.parse(JSON.stringify(this.products ?? []));
    const creteProduct = prods => prods.map(
      prod => new Product(
        prod.id,
        prod.name,
        prod.id,
        0,
        false,
        this.calculateBonuses,
      ),
    );
    let products = [];
    if (this.ticket) {
      const selectedProducts = [];
      products = creteProduct(actionProducts);
      this.ticket.positions.forEach((position) => {
        const { product } = position;
        const foundProduct = products.find(el => el.id === product.id);
        if (!foundProduct) return;
        foundProduct.quantity = position.quantity;
        foundProduct.checked = position.quantity > 0;
        foundProduct.product_id = position.product_id;
        foundProduct.model_photos = position.model_photos ?? [];
        foundProduct.number_photos = position.number_photos ?? [];
        selectedProducts.push(foundProduct.id);
      });
      this.selectedItemsInTable = selectedProducts;
    } else {
      products = creteProduct(actionProducts);
    }
    this.displayProducts = products;
    this.calculateBonuses();
  },
};
